import type { SVGProps } from "react";

const SvgJTBankLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 46.08 46.08"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2,
    }}
    {...props}
  >
    <path
      style={{
        fill: "#103933",
      }}
      transform="scale(1.92)"
      d="M0 0h24v24H0z"
    />
    <path
      d="M40.412 8.647h5.124V27.25h9.006V8.647h5.1V.687h-19.23zM6.318 19.29H0v7.96h9.19q.62.039 1.24 0a5.85 5.85 0 0 0 5.009-5.62V.685H6.433zm33.13-1.652V15.55H36.69v3.603l-10.545-8.557a3.98 3.98 0 0 1-1.86-3.716c0-3.487 2.297-3.601 5.145-3.601 3.975 0 4.458.665 4.595 4.037v1.445h3.01V7.316c0-5.597-2.688-6.698-7.513-6.698-5.215 0-8.156 1.032-8.156 6.262a5.42 5.42 0 0 0 2.298 5.253c-3.4.94-5.422.78-5.422 7.203 0 8.282 4.204 8.259 10.109 8.259 4.25 0 8.385 0 9.902-3.464l3.951 3.234 1.632-2.087-4.825-3.808c.234-1.225.342-2.47.322-3.716zM28.35 24.934c-6.272 0-7.1-.39-7.1-5.552 0-4.22.391-4.748 4.297-5.643l10.407 8.327c-.643 2.914-4.732 2.661-7.581 2.661zm55.943-11.677c2.504-.963 3.056-2.867 3.056-5.528a8.48 8.48 0 0 0-1.241-5.276A5.88 5.88 0 0 0 81.1.64H67.637v26.61h14.13a5.9 5.9 0 0 0 4.893-1.95 8.75 8.75 0 0 0 1.448-5.529c0-3.12-.529-5.712-3.814-6.469zM70.9 3.715h8.822c3.124 0 4.32.298 4.365 3.785 0 4.083-1.126 4.725-4.595 4.771H70.97zm9.19 20.645H70.9v-9.176h9.902c3.676 0 4.066 1.606 4.09 5.024 0 3.969-1.425 4.221-4.596 4.267zm19-23.536-9.696 26.564h3.423l2.045-5.574h13.096l2.067 5.574h3.378L103.478.824zm-3.332 18.352 5.468-15.461 5.675 15.254zM180.351.824h-4.411l-9.627 26.404-13.463-13.535L165.027.824h-4.297l-10.729 11.47h-2.297V.824h-3.263v26.427h2.987V15.184h2.298l12.038 12.158h7.628l2.045-5.574h13.095l2.068 5.574h3.4zm-7.72 18.352 5.468-15.461 5.652 15.254zm-37.379 5.184L120.686.595h-5.147V27.25h3.263V3.715l14.635 23.582h5.077V.687h-3.262z"
      style={{
        fill: "#fff",
        fillRule: "nonzero",
      }}
      transform="translate(4.54 20.295)scale(.19474)"
    />
  </svg>
);
export default SvgJTBankLogo;
